export default {
  data() {
    return {
      unReadList: [],
    }
  },
  methods: {
    async getUserUnreadMessageList() {
      const params = {
        pageNum: 1,
        pageSize: 50,
      }

      try {
        const res = await this.fetch.post('getUserUnreadMessageList', params)
        if (res) {
          this.unReadList = (res.data?.data || []).map(item => ({
            ...item,
            readStatus: item.readStatusDesc,
          }))
        } else {
          this.unReadList = []
        }
      } catch (err) {
        this.$addOwlError({
          name: `【全局弹窗-消息提醒】消息列表获取失败_${err.message}`,
          msg: err,
        })
      }
    },
  },
}
